var exports = {
  "k": "x9245d464--65cfb5--container",
  "R": "x9245d464--65cfb5--heading",
};

module.exports = exports;
